module.exports = __webpack_public_path__ + "static/media/pro.19943a17.svg";